import type { FollowCompany } from "@/modules/companies/client/api/types"
import type { NextRequest } from "@/modules/fetch/types"
import type { ObjectToCamel } from "@/modules/format/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"
import { toSnakeCaseKeys } from "@/modules/format/object/toSnakeCaseKeys"

type FollowCompanyRequest = {
  company_id: string
  follow: boolean
  nextRequest?: NextRequest
}
const FOLLOW_COMPANY_ENDPOINT = "/jobteaser.company.follow.v1alpha1/FollowService/Follow"
const UNFOLLOW_COMPANY_ENDPOINT = "/jobteaser.company.follow.v1alpha1/FollowService/Unfollow"

export const setFollowCompanyStatus = async ({
  follow,
  nextRequest,
  ...restParams
}: FollowCompanyRequest): Promise<ObjectToCamel<FollowCompany>> => {
  const path = follow ? FOLLOW_COMPANY_ENDPOINT : UNFOLLOW_COMPANY_ENDPOINT

  return fetcher(path, {
    nextRequest,
    requestInit: {
      body: JSON.stringify(toSnakeCaseKeys(restParams)),
      method: "POST",
    },
    serviceDomain: "APIGW_IN_KRAKEND_API",
  })
    .then(getResultFromResponse<FollowCompany, ObjectToCamel<FollowCompany>>({ transformResult: toCamelCaseKeys }))
    .catch(handleFetchError(path, restParams))
}
